/* UGC reels: tap-to-play with sound (user gesture), one reel at a time,
   arrows step the rail, offscreen reels pause. */
(() => {
  const init = (root) => {
    if (root.movUgcInit) return;
    root.movUgcInit = true;

    const rail = root.querySelector('[data-ugc-rail]');
    const cards = [...root.querySelectorAll('[data-ugc-card]')];
    if (!rail || !cards.length) return;

    const pauseCard = (card) => {
      const v = card.querySelector('[data-ugc-video]');
      if (v && !v.paused) v.pause();
      card.classList.remove('is-playing');
    };

    cards.forEach((card) => {
      const video = card.querySelector('[data-ugc-video]');
      if (!video) return;
      const toggle = () => {
        if (video.paused) {
          cards.forEach((c) => c !== card && pauseCard(c));
          video.play();
          card.classList.add('is-playing');
        } else {
          pauseCard(card);
        }
      };
      card.querySelector('[data-ugc-play]').addEventListener('click', toggle);
      video.addEventListener('click', toggle);
    });

    const step = () => {
      const gap = parseFloat(getComputedStyle(rail).gap) || 16;
      return cards[0].getBoundingClientRect().width + gap;
    };
    root.querySelector('[data-ugc-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    root.querySelector('[data-ugc-next]')?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => entries.forEach((e) => !e.isIntersecting && pauseCard(e.target)),
        { threshold: 0.2 }
      );
      cards.forEach((c) => io.observe(c));
    }
  };

  const initAll = (root) => root.querySelectorAll('[data-ugc]').forEach(init);
  initAll(document);
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
